export default "__VITE_ASSET__hLrAbhiA__"